import type { DragData } from "./dragData"

/**
 * A place a drag can be dropped on, as dragKind is a thing that can be
 * dragged. A place there is one of says only which place it is; a place there
 * are many of, such as a card, carries a value that tells them apart. Its key
 * is a symbol only the zone holds, so nothing else is taken for it.
 */
export function dropZone<T = void>(name: string) {
  const key = Symbol(name)
  return {
    /** Tags a drop target's data as this zone, with its value if it has one. */
    data: (...[value]: T extends void ? [] : [value: T]) => ({
      [key]: { value },
    }),
    /** Whether a drop target's data is this zone's. */
    is: (data: DragData) => key in data,
    /** The value this zone's data carries, if the data is this zone's. */
    from: (data: DragData) => (data[key] as { value: T } | undefined)?.value,
  }
}

export type DropZone<T = void> = ReturnType<typeof dropZone<T>>
